import axios from 'axios'
import env from './../env'

var service = axios.create({ timeout: 1000 * 20, baseURL: env.baseURL })

service.interceptors.request.use(
    function (config) {
        let authHeader = config.headers['Authorization']
        if (authHeader) {
            //console.log("already added authHeader, getProviderInfo call, no need to use providerKey")
        } else {
            if (config.url.includes('stripe')) {
                config.headers['Authorization'] = 'Bearer ' + env.stripe_public_key;
                config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
            }
        }
        return config
    },
    function (error) {
        return Promise.reject(error)
    }
)

service.interceptors.response.use(function (response) {
    //console.log(response.data)
    return response
}, function (error) {
    return Promise.reject(error)
})

export default service